import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import socketModule from './socket';
import eventsModule from './events';
import userModule from '@shared/js/store/modules/user';
import deviceModule from '@shared/js/store/modules/device';
import followingModule from '@shared/js/store/modules/following';
import featureTokensModule from '@shared/js/store/modules/featureTokens';
import notificationsModule from './notifications';

Vue.use(Vuex);
Vue.use(VueCookies);

const store = new Vuex.Store({
	modules: {
		socket:        socketModule,
		notifications: notificationsModule,
		events:        {
			...eventsModule,
			modules: {},
		},
		user:          userModule,
		device:        deviceModule,
		following:     followingModule,
		featureTokens: featureTokensModule,
	},
});

store.dispatch('device/init');
store.dispatch('featureTokens/init');

export default store;
